import axiosClient from 'utils/axiosClient';
import { Genre } from '../../models/Genre';

export interface GenreResponse {
  status: string;
  message: string;
  data: Genre;
}

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  getGenre(id: string): Promise<GenreResponse> {
    const url = `genre/${id}`;
    return axiosClient.get(url);
  },
  updateGenre(body: Genre, id: string): Promise<GenreResponse> {
    const url = `genre/${id}`;
    return axiosClient.put(url, body, config);
  },
};

export default service;
